<script>
    //@ts-nocheck
    import {
        Disclosure,
        DisclosureGroup,
        Typography,
        Alert,
    } from '$lib/components/UI'
</script>

<div
    style="width: 100%; padding: 50px 70px; display: flex; flex-direction:column; align-items: center; gap: 20px; position: relative"
>
    <Typography type="h2">Preguntas Frecuentes</Typography>
    <DisclosureGroup>
        <Disclosure label="1. Alta/Modificación">
            <DisclosureGroup>
                <Disclosure
                    label="1.1. ¿Qué información y documentos debo tener a mano para darme de alta como proveedor?"
                >
                    <ul>
                        <li>
                            Datos de la empresa como:
                            <ul>
                                <li>Documento</li>
                                <li>Dirección</li>
                                <li>Mail de contacto</li>
                            </ul>
                        </li>
                        <li>Información fiscal e impositiva</li>
                        <li>
                            Documentación respaldatoria tanto constancias de
                            inscripción como constancias de excepción (En casos
                            de contar con alguna excepción de impuestos)
                        </li>
                        <li>Información laboral o previsional</li>
                        <li>
                            Información para la acreditación de cuenta:
                            <ul>
                                <li>Banco</li>
                                <li>CBU</li>
                                <li>Datos del Titular</li>
                            </ul>
                        </li>
                    </ul>
                </Disclosure>
                <Disclosure
                    label="1.2. ¿En qué formato debo cargar la documentación respaldatoria y facturas a presentar?"
                >
                    Todos los archivos y/o documentos que debas cargar en este
                    portal deberán ser en formato PDF que se encuentre legible.
                </Disclosure>
            </DisclosureGroup>
        </Disclosure>
        <Disclosure label="2. Portal">
            <DisclosureGroup>
                <Disclosure
                    label="2.1. ¿Qué datos debo incorporar en la factura digital o documento equivalente como OBLIGATORIO (teniendo orden de compra)?"
                >
                    <ul>
                        <li>N°. de Pedido de compra.</li>
                        <li>
                            N°. de hoja de entrada de materiales/servicios o de
                            otras certificaciones/habilitaciones otorgadas a tal
                            efecto.
                        </li>
                        <li>
                            Provincia de entrega de materiales o de prestación
                            del servicio y montos relacionados. Este dato será
                            utilizado para la correcta determinación de las
                            retenciones a aplicar. En caso de imposibilidad de
                            incorporar estos datos en el documento emitido se
                            deberá incluir en el cuerpo del mail.
                        </li>
                    </ul>
                </Disclosure>
                <Disclosure
                    label="2.2. Debo informar el lugar de Prestación de Servicio y/o entrega de mercaderías?"
                >
                    Deberás informar en el cuerpo de la/s factura/s la/s
                    provincia/s donde prestaste el servicio o entregaste la
                    mercadería. En el caso que se trate de entregas o servicios
                    prestados en más de una provincia, también deberás desglosar
                    el importe correspondiente a cada una, a efectos de realizar
                    la correcta aplicación del impuesto.
                </Disclosure>
                <Disclosure
                    label="2.3. Que debo tomar en cuenta para evitar inconvenientes y/o rechazos de facturas."
                >
                    <ul>
                        <li>
                            Recuerde verificar y mantener actualizada su
                            situación fiscal a través de este portal en la
                            sección "Información Impositiva" (¿Puede ir en link
                            directo a la sección?).
                        </li>
                        <li>
                            Verifique que sus certificados de inscripción o
                            excepción se encuentren vigentes y/o cargados según
                            corresponda el caso en la sección "Documentación"
                            (¿Puede ir en link directo a la sección?).
                        </li>
                        <li>
                            Verifique antes de facturar la condición impositiva
                            de Caja de Seguros SA y/o empresas del grupo.
                            (¿Puede ir en link directo a la sección?).
                        </li>
                        <li>
                            Se considerará en la liquidación de facturas, la
                            última situación fiscal que el proveedor haya
                            informado a Caja de Seguros con antelación a la
                            presentación de las mismas.
                        </li>
                        <li>
                            Será responsabilidad del proveedor mantener
                            actualizado su legajo en tiempo y forma.
                        </li>
                        <li>
                            La modificación comunicada por el proveedor se verá
                            reflejada en los sistemas de Caja de Seguros SA, en
                            un plazo no menor a 5 días hábiles (por ejemplo) a
                            la comunicación oficial de las mismas.
                        </li>
                    </ul>
                </Disclosure>
            </DisclosureGroup>
        </Disclosure>
        <Disclosure label="3. Impuestos">
            <DisclosureGroup>
                <Disclosure
                    label="3.1. ¿Qué debo tomar en cuenta para según mis retenciones?"
                >
                    <ul>
                        <li>
                            A efectos de que las retenciones se apliquen en
                            forma correcta solicitamos mantener actualizada tu
                            documentación fiscal e impositiva.
                        </li>
                        <li>
                            Recordá que bajo ninguna circunstancia se dará curso
                            a reclamos de devolución de retenciones impositivas
                            una vez transcurridas las 72hs de efectuado el pago.
                        </li>
                        <li>
                            En caso en que no se indique en tu factura la
                            jurisdicción donde se entregaron los productos y/o
                            servicios y corresponde la retención de IIBB se
                            aplicará indefectiblemente la retención
                            correspondiente a la jurisdicción del domicilio
                            declarado en el membrete de la factura y el mismo no
                            tendrá posibilidad de devolución de no coincidir con
                            el que efectivamente correspondiere.
                        </li>
                        <li>
                            De contar con alguna exención con relación a la
                            retención de Ingresos Brutos, también deberás
                            hacerlo constar en la factura. Además, deberás
                            remitir al Centro de Atención a Proveedores el
                            correspondiente respaldo de Rentas a efectos que sea
                            mantenida tu situación en los registros maestros de
                            la compañía, de no cumplimentar lo antedicho Caja de
                            Seguros SA no se hará responsable por cualquier
                            deducción que por este concepto se practique en la
                            liquidación de tus facturas.
                        </li>
                    </ul>
                </Disclosure>
                <Disclosure
                    label="3.2. ¿Qué debo tener en cuenta si soy Proveedor emisor de facturas de Crédito Electrónica?"
                >
                    <ul>
                        <li>
                            Es fundamental que no pasen más de 48hs entre la
                            emisión de la factura y la presentación en el buzón
                            XX.
                        </li>
                        <li>
                            Los rechazos de facturas se realizarán a través del
                            portal de la AFIP, realice el seguimiento del estado
                            de sus documentos en dicho portal. Por favor
                            verificar en las preguntas frecuentes la
                            documentación habilitante y obligatoria a presentar
                            y/o a incorporar.
                        </li>
                    </ul>
                </Disclosure>
            </DisclosureGroup>
        </Disclosure>
    </DisclosureGroup>
    <Alert type="info"
        >En caso de tener algún inconveniente, error o duda con respecto al
        portal, podrá contactarse con la persona que le realizo la invitación o
        algún contacto interno que tenga en La Caja.</Alert
    >
</div>
